import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=34db95d2&scoped=true&lang=pug&"
import script from "./SubNav.vue?vue&type=script&lang=js&"
export * from "./SubNav.vue?vue&type=script&lang=js&"
import style0 from "./SubNav.vue?vue&type=style&index=0&id=34db95d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34db95d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34db95d2')) {
      api.createRecord('34db95d2', component.options)
    } else {
      api.reload('34db95d2', component.options)
    }
    module.hot.accept("./SubNav.vue?vue&type=template&id=34db95d2&scoped=true&lang=pug&", function () {
      api.rerender('34db95d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/SubNav.vue"
export default component.exports